<template>
  <div class="air-monitor-base-container air-device-info">
    <MCard :title="$t('设备信息')" title-align="center">
      <MForm v-bind="formConfig" />

      <MTable
        i18n-path="query"
        height="100%"
        :loading="loading"
        :tableData="tableData"
        :tableColumn="tableColumn"
        :hasPagination="false"
        v-on:search="search"
      ></MTable>
    </MCard>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table';
import MCard from '@/components/mCard/index.vue';
import MForm from '@/components/form/index.vue';

import { getDeviceList } from '@/api/air-monitor/device-center';
import { isEmpty } from '@/utils/is';

export default {
  components: {
    MForm,
    MCard,
    MTable
  },
  props: {
    sn: String
  },
  data() {
    return {
      loading: false,
      formConfig: {
        i18nPath: 'query',
        config: {
          labelWidth: 'auto',
          span: 24,
          labelSuffix: ':',
          options: [
            {
              type: 'input',
              prop: 'name',
              span: 5,
              label: '设备名称'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '查询',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  await this.search();
                  setLoading(false);
                }
              }
            ]
          }
        },
        model: {
          name: ''
        },
        dataSource: {},
        rules: {}
      },
      tableData: [],
      tableColumn: [
        { label: '设备号', prop: 'sn' },
        { label: '设备名', prop: 'busiName' },
        { label: '设备类型', prop: 'deviceTypeName' },
        { label: '位置', prop: 'location_desc_show' }
      ]
      // pagiOption: {
      //   offset: 1,
      //   limit: 10,
      //   total: 0,
      //   pagiSize: [10, 15, 20, 30],
      //   layout: 'total, sizes, prev, pager, next, jumper'
      // }
    };
  },
  methods: {
    async search() {
      try {
        this.loading = true;
        const res = await getDeviceList(this.formConfig.model);
        res.data.forEach(item => {
          item.location_desc_show = '';
          if (!isEmpty(item.dynamicInfoMap)) {
            item.location_desc_show = item.dynamicInfoMap.location_desc;
          }
        });

        this.tableData = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.search();
  }
};
</script>

<style lang="scss">
.air-device-info {
  .m-table {
    height: calc(100% - 75px) !important;
  }
}
</style>
